import React from "react";
import { MobileOutlined } from "@ant-design/icons";
import AuthService from "../../base/services/authentication.service";
import { UserRolesEnum } from "../../pages/auth/userRoles.enum";
import "./MobileAppButton.scss";

const APP_STORE_URL = "https://apps.apple.com/app/kapsurvey/id6717611279";
const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=com.iaps.kapsurvey";

// The store for the phone or tablet this page is open on; null on a computer.
const getDeviceStoreUrl = () => {
   const { userAgent, maxTouchPoints } = window.navigator;
   if (/android/i.test(userAgent)) return GOOGLE_PLAY_URL;
   // iPadOS reports itself as a Mac; only the touch screen tells them apart.
   if (
      /iphone|ipad|ipod/i.test(userAgent) ||
      (/macintosh/i.test(userAgent) && maxTouchPoints > 1)
   ) {
      return APP_STORE_URL;
   }
   return null;
};

/**
 * "Get the app" pill in the header for data collectors on a phone or tablet,
 * linking straight to that device's store. Not shown on a computer.
 */
const MobileAppButton = () => {
   if (!AuthService.isAuthorized([UserRolesEnum.DataCollector])) return null;

   const storeUrl = getDeviceStoreUrl();
   if (!storeUrl) return null;

   return (
      <a className="mobile-app-button" href={storeUrl} target="_blank" rel="noopener noreferrer">
         <MobileOutlined />
         <span className="mobile-app-button__label">Get the app</span>
      </a>
   );
};

export default MobileAppButton;
